import styled from 'styled-components'

import { cssTypes } from '../types'
import { css } from '../util'

/**
 * @namespace Form
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Form = styled.form.attrs({
  action: '',
})`
  ${css};
`

/**
 * @name defaultProps
 * @memberof Form
 * @desc Primitive's default properties
 */
Form.defaultProps = {}

/**
 * @name propTypes
 * @memberof Form
 * @desc Primitive's prop type definitions
 */
Form.propTypes = {
  ...cssTypes,
}

/** @component */
export default Form
